import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyA9q67ak0HWmrcUCSggOQYmmnvfuu0mM0I",
  authDomain: "dwindl.firebaseapp.com",
  projectId: "dwindl",
  storageBucket: "dwindl.firebasestorage.app",
  messagingSenderId: "1002101135860",
  appId: "1:1002101135860:web:9039733d0eeb80a3d381a1",
  measurementId: "G-5GJ0XH5F9S"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
auth.useDeviceLanguage();

const analytics = getAnalytics(app);

export { auth, analytics };